import { generateSensorReadingsBlock } from './sensor-readings';
import { generateStateBlocks } from './state-blocks';
import { generateLogicBlocks } from './logic-blocks';
import { generateDoBlocks } from './do-blocks';
import { mainB2X } from '../convertors/blockly-2-xml';
import { generateHeatModeBlocks } from './heat-modes';
import { generateTimeComparatorBlocks } from './time-comparators';
import { generateRunBlocks } from './runs';
import { BlocklyError } from '../utils/blockly-error';
import { mainC2B } from 'console/blockly/convertors/config-2-bloclky/main';
function generateCategory(props) {
    const { name, colour, config, current_scenario, generate_function } = props;
    const blocks = generate_function(colour, config, current_scenario);
    return blocks.length > 0
        ? {
            kind: 'category',
            name,
            colour,
            contents: [
                ...blocks.map((block_type) => ({
                    kind: 'block',
                    type: block_type,
                })),
            ],
        }
        : null;
}
export function generateToolbox(config, current_scenario) {
    return {
        kind: 'categoryToolbox',
        contents: [
            generateCategory({
                name: 'Запуск',
                colour: '#5ca25c',
                current_scenario,
                config,
                generate_function: generateRunBlocks,
            }),
            generateCategory({
                name: 'Логика',
                colour: '#d47d2e',
                current_scenario,
                config,
                generate_function: generateLogicBlocks,
            }),
            generateCategory({
                name: 'Значения датчиков',
                colour: '#4c9dd5',
                current_scenario,
                config,
                generate_function: generateSensorReadingsBlock,
            }),
            generateCategory({
                name: 'Время',
                colour: '#a44d92',
                current_scenario,
                config,
                generate_function: generateTimeComparatorBlocks,
            }),
            generateCategory({
                name: 'Состояния',
                colour: '#21a695',
                current_scenario,
                config,
                generate_function: generateStateBlocks,
            }),
            generateCategory({
                name: 'Действия',
                colour: '#67439b',
                current_scenario,
                config,
                generate_function: generateDoBlocks,
            }),
            generateCategory({
                name: 'Режимы отопления',
                colour: '#2332a7',
                current_scenario,
                config,
                generate_function: generateHeatModeBlocks,
            }),
        ],
    };
}
export function generateWorkspace(config, scenario) {
    let blockly_JSON = null;
    try {
        if (scenario.links.length > 0) {
            blockly_JSON = mainC2B(config, scenario);
        }
    }
    catch (e) {
        throw new BlocklyError('generateWorkspace', e);
    }
    return mainB2X(blockly_JSON);
}
